
import { usePinia, useSearchWizardStore } from '#imports'
import { Component, Vue } from '~/utility/pu-class-decorator'

@Component({
  setup() {
    const searchWizardStore = useSearchWizardStore(usePinia())
    return {
      searchWizardStore,
    }
  },
})
export default class FilterAndSortFooter extends Vue {
  searchWizardStore: ReturnType<typeof useSearchWizardStore>

  get count() {
    return this.searchWizardStore.totalCounts
  }
}
